import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FileUpload } from 'src/components/molecules';
import { useGetPublicCategoriesQuery } from 'src/graphql';
import * as Types from 'src/types';
import { addingFilesAsEvidenceIntercomArticle } from 'src/utils/intercomArticles';
import i18next from '../../../../i18n';
import QuestionContainer from '../QuestionContainer';
import {
  InputContainer,
  IntercomLink,
  QuestionDescription,
  StyledText,
} from './EvidenceQuestion.styles';

export const MAX_FILE_UPLOAD = 10;
interface Props {
  organisation: string;
  i18nHeader: Types.TranslationKey;
  i18nDescription: Types.TranslationKey;
  percentage: number;
  publicReport: Types.PublicReport;
}

export const EvidenceQuestion: React.FC<Props> = (props) => {
  const { data: publicCategories } = useGetPublicCategoriesQuery({
    slug: props.organisation ?? '',
  });

  const selectedCategory = publicCategories?.getPublicCategories?.find(
    (cat) => cat.id === props.publicReport.reportedCategory,
  );
  const isQuestionFlowReport = selectedCategory?.question;

  const nextLink = isQuestionFlowReport ? 'details' : 'perpetrators';
  const backLink = isQuestionFlowReport ? 'question' : 'witnesses';

  return (
    <QuestionContainer
      organisation={props.organisation}
      backLink={backLink}
      nextLink={nextLink}
      submitAnswer={() => {}}
      i18nHeader={props.i18nHeader}
      percentage={props.percentage}
      setMinHeight={false}
    >
      <EvidenceQuestionContent i18nDescription={props.i18nDescription} />
    </QuestionContainer>
  );
};

interface EvidenceQuestionContentProps {
  i18nDescription: Types.TranslationKey;
}

const EvidenceQuestionContent: React.FC<EvidenceQuestionContentProps> = (
  props,
) => {
  const { t } = useTranslation();
  const linkComponentToBeEmbedded = (
    <IntercomLink
      href={addingFilesAsEvidenceIntercomArticle}
      size="medium"
      target="_blank"
      rel="no-referrer"
      data-testid="file-upload-help-article-link"
    />
  );

  return (
    <InputContainer>
      <QuestionDescription>{t(props.i18nDescription)}</QuestionDescription>
      <StyledText>
        <Trans
          i18n={i18next}
          i18nKey="public.FileUpload.moreInformation"
          components={{
            a: linkComponentToBeEmbedded,
          }}
        />
      </StyledText>

      <FileUpload
        dragDropText={t('public.FileUpload.dragDrop')}
        highlightedText={t('public.FileUpload.highlighted')}
        fileLimitText={t('public.FileUpload.fileLimit')}
        informationText={t('public.FileUpload.information')}
        addFilesButtonText={t('public.FileUpload.addFiles')}
        tooltipFileOptions={[
          {
            type: t('public.FileUpload.tooltipImage'),
            options: t('public.FileUpload.tooltipImageOptions'),
          },
          {
            type: t('public.FileUpload.tooltipText'),
            options: t('public.FileUpload.tooltipTextOptions'),
          },
          {
            type: t('public.FileUpload.tooltipVideo'),
            options: t('public.FileUpload.tooltipVideoOptions'),
          },
          {
            type: t('public.FileUpload.tooltipAudio'),
            options: t('public.FileUpload.tooltipAudioOptions'),
          },
          {
            type: t('public.FileUpload.tooltipDocuments'),
            options: t('public.FileUpload.tooltipDocumentsOptions'),
          },
        ]}
        uploadFilesButtonText={t('public.FileUpload.uploadFiles')}
      />
    </InputContainer>
  );
};

export default EvidenceQuestion;
